export const HandoverQueries = {
  GET_LIST_HANDOVER: `query GetHandOverByPurchase($input: GetHandOverInput!, $skip: Float, $take: Float){
    getHandOverList(input: $input
    skip: $skip
    take: $take
    ){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
           implementationDate
           implementationEndDate
           plantId
           plantName
           routeId
           routeName
           customerId
           customerName
           mainCustomerId
           sapCustomerId
           teamSalesId
           teamSalesIdSap
           teamSalesName
           orderIds
           sumPaymentIds
           purchaseOrderIds
           totalOrderFinalPrice
           totalOrderQ10
           totalPurchaseFinalPrice
           totalPurchaseQ10
           totalFinalPrice
           totalQ10
           handOverFinalPrice
           handOverQ10
           treasurerId
           treasurerName
           handOverImplementationDate
           warehouseAdministerId
           warehouseAdministerName
           warehouseDate
           treasurerId
           treasurerName
           treasurerDate
           createId
           createDate
           createName
           modifyId
           modifyName
           modifyDate
        }
    }
}`,
  CONFIRM_HANDOVER: `mutation CreateHandOver($input: CreateHandOverInput!){
    createHandOver(input: $input){
      code
      success
      message
      data{
        id
        implementationDate
        q10
        handOverQ10
        finalPrice
        handOverFinalPrice
        
      }  
    }
}`,
};
